"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRuntimeConfig = exports.getAppEnv = exports.Env = void 0;
const process_1 = __importDefault(require("process"));
const envalid_1 = require("envalid");
var Env;
(function (Env) {
    Env["Dev"] = "dev";
    Env["Prod"] = "prod";
    Env["Qa"] = "qa";
    Env["Stage"] = "stage";
})(Env = exports.Env || (exports.Env = {}));
const getAppEnv = () => {
    const env = (0, envalid_1.cleanEnv)(process_1.default.env, {
        AG_GRID_LICENSE: (0, envalid_1.str)({ default: '' }),
        ANALYZE: (0, envalid_1.bool)({ default: false }),
        APP_URL: (0, envalid_1.str)({ default: '' }),
        AUTH_COOKIE_DOMAIN: (0, envalid_1.str)({ default: 'localhost' }),
        DATADOG_CLIENT_TOKEN: (0, envalid_1.str)({ default: '' }),
        DD_ENV: (0, envalid_1.str)({ default: '' }),
        DD_SERVICE: (0, envalid_1.str)({ default: '' }),
        DD_TRACE_ENABLED: (0, envalid_1.bool)({ default: false }),
        DD_VERSION: (0, envalid_1.str)({ default: '' }),
        ENV: (0, envalid_1.str)({ choices: Object.values(Env), default: Env.Dev }),
        EVEN_CMS_URL: (0, envalid_1.url)({ default: 'https://cms.evenfinancial.com' }),
        NEXT_PUBLIC_CMS_TOKEN: (0, envalid_1.str)({ default: '' }),
        NEXT_PUBLIC_HOTJAR_ID: (0, envalid_1.num)({ default: 0 }),
        NEXT_PUBLIC_HOTJAR_SV: (0, envalid_1.num)({ default: 0 }),
        NEXT_PUBLIC_OKTA_CLIENT_ID: (0, envalid_1.str)({ default: '' }),
        NEXT_PUBLIC_OKTA_ORG_URL: (0, envalid_1.url)({
            default: 'https://evenfinancialapp.oktapreview.com',
        }),
        NEXT_PUBLIC_RECURLY_PUBLIC_KEY: (0, envalid_1.str)({ default: '' }),
        NEXT_PUBLIC_TABLEAU_REPORTS_URL: (0, envalid_1.url)({
            default: 'https://prod-useast-a.online.tableau.com/t/tableaueven/views/BenchmarkReportsProduction-3_0/LenderBenchmarking',
        }),
        NODE_ENV: (0, envalid_1.str)({ default: 'dev' }),
        PORT: (0, envalid_1.num)({ default: 9000 }),
        PORTAL_API_URL: (0, envalid_1.str)({ default: '' }),
        PP_EVEN_BASE_URL: (0, envalid_1.url)({
            default: 'https://dev.consumer.evenfinancial.com',
        }),
        PP_FIONA_BASE_URL: (0, envalid_1.url)({
            default: 'https://dev.fiona.com/partner',
        }),
        PP_LEAPLIFE_BASE_URL: (0, envalid_1.url)({
            default: 'https://dev.leaplife.com/partner',
        }),
        RECURLY_PUBLIC_KEY: (0, envalid_1.str)({ default: '' }),
        SENTRY_DSN: (0, envalid_1.str)({ default: '' }),
        SENTRY_ENV: (0, envalid_1.str)({ default: 'development' }),
        TABLEAU_BASE_URL: (0, envalid_1.url)({ default: 'https://tableau.evenfinancial.com/' }),
        TABLEAU_FOLDER: (0, envalid_1.str)({ default: 'BenchmarkReportsProduction-V11_1' }),
        docker_version: (0, envalid_1.str)({ default: '' }),
    });
    const PARTNER_PAGE_BASE_URLS = {
        evenBaseUrl: env.PP_EVEN_BASE_URL,
        fionaBaseUrl: env.PP_FIONA_BASE_URL,
        leaplifeBaseUrl: env.PP_LEAPLIFE_BASE_URL,
    };
    return Object.assign(Object.assign({}, env), { IS_PRODUCTION_ENV: env.ENV === 'prod', IS_QA_ENV: env.ENV === 'qa', IS_SERVER: typeof window !== 'undefined', IS_STAGING_ENV: env.ENV === 'stage', PARTNER_PAGE_BASE_URLS });
};
exports.getAppEnv = getAppEnv;
const getRuntimeConfig = () => {
    return (0, exports.getAppEnv)();
};
exports.getRuntimeConfig = getRuntimeConfig;
